import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { setIncidentDate } from 'containers/App/actions';
import { makeSelectJobLossHardshipStep, makeSelectJobLossHardshipStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import {
  emailMedicalTravelDocument,
} from '../actions';
import JobLossHardshipStepShared from './components/JobLossHardshipStepShared';
export class JobLossHardshipStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    this.props.setIncidentDate(dayWithoutTimeZone);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
    ? reasonsForTripInterruption.toJS()
    : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
    ? reasonsForDelay.toJS()
    : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  renderJobLossHardshipForm() {
    const {
      employerName,
      employerEmail,
      address1,
      address2,
      city,
      state,
      province,
      country,
      zipOrPostalCode,
      dateOfTerminationRedundancy,
      howManyYearsDidYouWorkThere,
      describe,
      areYouGainfullyEmployedNow,
      haveYouBeenEmployedFullTime,
      haveYouFiledForUnemploymentBenefits,
      wasYourEmploymentStatusSeasonal,
      wasYourEmploymentStatusRetiredOrResigned,
      haveYouBeenContinuouslyUnemployed,
      newEmployerName,
      newEmployerAddress,
      dateYouBeganNewEmployment,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="employerName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={employerName}
                  fieldName={messages.employerName}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="employerName"
                      type="text"
                      onChange={this.handleChange('form.employerName')}
                      value={employerName}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.employerName}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="employerEmail"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={employerEmail}
                  fieldName={messages.employerEmail}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="employerEmail"
                      type="text"
                      onChange={this.handleChange('form.employerEmail')}
                      value={employerEmail}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.employerEmail}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.employerMailingAddress} />
            </PageSectionHeader>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="address1"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={address1}
                  fieldName={messages.address1}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="address1"
                      type="text"
                      onChange={this.handleChange('form.address1')}
                      value={address1}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.address1}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="address2"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={address2}
                  fieldName={messages.address2}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="address2"
                      type="text"
                      onChange={this.handleChange('form.address2')}
                      value={address2}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.address2}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>   
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
                <Validate
                  name="city"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={city}
                  fieldName={messages.city}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="address1"
                      type="text"
                      onChange={this.handleChange('form.city')}
                      value={city}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.city}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="state"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={state}
                  fieldName={messages.state}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="state"
                      type="text"
                      onChange={this.handleChange('form.state')}
                      value={state}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.state}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="province"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={province}
                  fieldName={messages.province}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="province"
                      type="text"
                      onChange={this.handleChange('form.province')}
                      value={province}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.province}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="address1"
                      type="text"
                      onChange={this.handleChange('form.country')}
                      value={country}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.country}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="zipOrPostalCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipOrPostalCode}
                  fieldName={messages.zipOrPostalCode}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="zipOrPostalCode"
                      type="number"
                      onChange={this.handleChange('form.zipOrPostalCode')}
                      value={zipOrPostalCode}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipOrPostalCode}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateOfTerminationRedundancy"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfTerminationRedundancy}
                  fieldName={messages.dateOfTerminationRedundancy}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfTerminationRedundancy"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfTerminationRedundancy')}
                    value={dateOfTerminationRedundancy}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfTerminationRedundancy}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfTerminationRedundancy}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="howManyYearsDidYouWorkThere"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={howManyYearsDidYouWorkThere}
                  fieldName={messages.howManyYearsDidYouWorkThere}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="howManyYearsDidYouWorkThere"
                      type="text"
                      onChange={this.handleChange('form.howManyYearsDidYouWorkThere')}
                      value={howManyYearsDidYouWorkThere}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.howManyYearsDidYouWorkThere}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouBeenEmployedFullTime} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouBeenEmployedFullTime === 'true'}
                    onChange={this.handleChange('form.haveYouBeenEmployedFullTime')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouBeenEmployedFullTime === 'false'}
                    onChange={this.handleChange('form.haveYouBeenEmployedFullTime')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouFiledForUnemploymentBenefits} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouFiledForUnemploymentBenefits === 'true'}
                    onChange={this.handleChange('form.haveYouFiledForUnemploymentBenefits')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouFiledForUnemploymentBenefits === 'false'}
                    onChange={this.handleChange('form.haveYouFiledForUnemploymentBenefits')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasYourEmploymentStatusSeasonal} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasYourEmploymentStatusSeasonal === 'true'}
                    onChange={this.handleChange('form.wasYourEmploymentStatusSeasonal')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasYourEmploymentStatusSeasonal === 'false'}
                    onChange={this.handleChange('form.wasYourEmploymentStatusSeasonal')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasYourEmploymentStatusRetiredOrResigned} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasYourEmploymentStatusRetiredOrResigned === 'true'}
                    onChange={this.handleChange('form.wasYourEmploymentStatusRetiredOrResigned')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasYourEmploymentStatusRetiredOrResigned === 'false'}
                    onChange={this.handleChange('form.wasYourEmploymentStatusRetiredOrResigned')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouBeenContinuouslyUnemployed} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouBeenContinuouslyUnemployed === 'true'}
                    onChange={this.handleChange('form.haveYouBeenContinuouslyUnemployed')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouBeenContinuouslyUnemployed === 'false'}
                    onChange={this.handleChange('form.haveYouBeenContinuouslyUnemployed')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
                <Validate
                  name="describe"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={describe}
                  fieldName={messages.describe}                  
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="describe"
                      type="text"
                      onChange={this.handleChange('form.describe')}
                      value={describe}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.describe}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouGainfullyEmployedNow} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouGainfullyEmployedNow === 'true'}
                    onChange={this.handleChange('form.areYouGainfullyEmployedNow')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouGainfullyEmployedNow === 'false'}
                    onChange={this.handleChange('form.areYouGainfullyEmployedNow')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {areYouGainfullyEmployedNow === 'true' &&
        <div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="newEmployerName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={newEmployerName}
                  fieldName={messages.newEmployerName}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="newEmployerName"
                      type="text"
                      onChange={this.handleChange('form.newEmployerName')}
                      value={newEmployerName}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.newEmployerName}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="newEmployerAddress"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={newEmployerAddress}
                  fieldName={messages.newEmployerAddress}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="newEmployerAddress"
                      type="text"
                      onChange={this.handleChange('form.newEmployerAddress')}
                      value={newEmployerAddress}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.newEmployerAddress}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
          </div>
          <div className={'ml-2 row'}>
            <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="dateYouBeganNewEmployment"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={dateYouBeganNewEmployment}
                    fieldName={messages.dateYouBeganNewEmployment}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateYouBeganNewEmployment"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateYouBeganNewEmployment')}
                      value={dateYouBeganNewEmployment}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.dateYouBeganNewEmployment}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.dateYouBeganNewEmployment}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
          </div>
          <div>
            <JobLossHardshipStepShared />
          </div>
        </div>}
      </div>
    );
  }

  render() {
    const { isSummary, submitted, loading } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div>
          {this.renderJobLossHardshipForm()}
        </div>
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

JobLossHardshipStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  sendPhysicianEmail: PropTypes.func,
  setIncidentDate: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectJobLossHardshipStep(),
  errors: makeSelectJobLossHardshipStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
  setIncidentDate: (date) => dispatch(setIncidentDate(date)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'jobLossHardshipStep', reducer });

export default compose(
  withReducer,
  withConnect
)(JobLossHardshipStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/index.js